import { styled } from '@mui/system'
import * as React from 'react'
import { Button, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useIntl } from 'react-intl'
import Stack from '@mui/material/Stack';
import DotTitle from './article/DotTitle';
import parse from 'html-react-parser';
import Media from './article/Media';
import ListPortrait from './article/ListPortrait';
import ListLink from './article/ListLink';

const RootDiv = styled(Stack)(({theme}) => ({
  flexDirection: "row",
  overflow: "auto",
}))

const DivArticle = styled(Stack)({
  position: "relative",
  width: "1122px",
  height: "100%",
})

const DivContent = styled(Stack)(({theme}) => ({
  width: "100%",
  flexDirection: "row",
  [theme.breakpoints.down('lg')]: {
    justifyContent: "center"
  },
  [theme.breakpoints.down('md')]: {
    justifyContent: "center",
    flexDirection: "column"
  }
}))

const ExitButton = styled(Button)({
  width: "215px",
  height: "34px",
  fontSize: "16px",
  color: '#929285',
  position: "absolute",
  left: '0px',
  top: "15px",
  textDecoration: "none",
})

const Category = styled('div')({
  borderTop: '3px solid #6d6c64',
  borderBottom: '1px solid #6d6c64',
  marginTop: '60px',
  height: '36px',
  paddingTop: '5px',
  position: 'relative',
  float: 'left'
})

const Title = styled(Typography)(({theme}) => ({
  width: "30%",
  minWidth: "25%",
  fontSize: '36px',
  lineHeight: '50px',
  paddingRight: "10px",
  color: "#6c6c6c",
  margin: "10px 0 15px 0",
  [theme.breakpoints.down('lg')]: {
    width: "100%",
    maxWidth: "100%",
    fontSize: "26px",
  }
}))

const ImageArticle = styled(Stack)(({theme}) => ({
  position: "relative",
  width: "calc(70% - 79px)",
  margin: '13px 0 31px 0',
  [theme.breakpoints.down('lg')]: {
    width: "100%",
  }
}))

const Description = styled('div')(({theme}) => ({
  width: '30%',
  float: 'left',
  fontSize: '24px',
  borderTop: '1px solid #6c6c6c',
  borderBottom: '1px solid #6c6c6c',
  marginTop: '37px',
  color: '#666666',
  lineHeight: '35px',
  position: 'relative',
  [theme.breakpoints.down('md')]: {
    width: "100%",
  }
}))

const Ancoche = styled('div')({
  position: 'absolute',
  top: '-5px',
  left: '0px',
  maxWidth: '34px',
  width: '34px',
  height: '5px',
  backgroundColor: '#686868',
})

const AllTexts = styled('div')(({theme}) => ({
  fontSize: '16px',
  color: '#303030',
  paddingTop: '31px',
  lineHeight: '28px',
  marginLeft: '30px',
  width: 'calc(70% - 31px)',
  float: 'left',
  columnWidth: '300px',
  [theme.breakpoints.down('md')]: {
    width: "100%",
  },
  '& .notedebasdepage': {
    fontSize: '12px',
    lineHeight: '1.4em',
    paddingBottom: '5px',
  },
  '& p': {
    margin: "0",
    color: "#4b4b4b"
  }
}))

const DivSeeMore = styled('div')({
  width: '175px',
  marginRight: '34px',
  float: 'left',
  paddingTop: '96px',
  marginLeft: '15px',
})

const SeeMore = styled('div')({
  width: "100%",
  position: "relative",
  height: '65px',
})

const SeeMoreText = styled(Typography)({
  width: '60px',
  float: "right",
  marginTop: "28px",
  fontSize: "16px",
  fontWeight: "800",
  color: '#4b4b4b'
})

const SeparationSeeMore = styled('div')({
  borderTop: "3px solid #6d6c64",
  position: "absolute",
  top: '40px',
  width: "50%",
  transform: "rotate(-45deg)"
})

const DivSectionSeeMore = styled('div')({
  width: '180px',
  float: 'right',
  marginBottom: '14px',
  borderLeft: '1px solid #929285',
  paddingLeft: '16px',
  marginTop: '18px',
})

const DivTitleSeeMore = styled(Typography)({
  width: '100%',
  borderTop: '3px solid #6d6c64',
  fontSize: '12px',
  fontWeight: '700',
  textTransform: 'uppercase',
  color: '#4b4b4b',
  paddingTop: '9px',
  paddingBottom: '5px',
  borderBottom: '1px solid #a4a596',
})

const DivRelatedRessource = styled('div')({
  margin: "5px 0px",
  fontSize: "12px",
  listStyleType: 'disc',
  '& p, ul': {
    margin: "0",
    color: "#4b4b4b",
    fontSize: "12px",
  },
  '& ul': {
    margin: "0",
    padding: "0 0 0 12px",
    color: "#4b4b4b",
    fontSize: "12px",
  },
})

const Article = React.forwardRef((props, ref) => {
  const intl = useIntl()
  const article = props.article;
  const handleClickItemLink = props.handleClickItemLink;
  const inFrise = props.inFrise;
  const inPortrait = props.inPortrait;

  return (
      <RootDiv justifyContent="center">
        <DivArticle>
          <ExitButton size='large' onClick={props.onClose} startIcon={<CloseIcon sx={{fontSize: "40px !important"}}/>}>{intl.formatMessage({ id: (inFrise) ? "exitArticle" : "exitPortrait" })}</ExitButton>
          <Category>
            <DotTitle
              section={(article?.type === 'portrait') ? 'Portrait' : article?.event_categorys[0].translations.find((translat) => (translat.lang === intl.locale)).title}
              color={(article?.type === 'portrait') ? "#6dd6c7" : "#" + article?.event_categorys[0].color}  
            />
          </Category>
          <DivContent flexWrap="wrap" alignItems="flex-start">
            <Title display="inline">{article?.date_start.substring(0, 4) + " : " + article?.translations.find((trans) => (trans.lang === intl.locale)).title}</Title>
            <ImageArticle display="inline" justifyContent="center" alignItems="center">
              <Media medias={article?.media.filter((m) => (m.type === 'image' || m.type === 'video'))}/>
            </ImageArticle>
            <Description component="div">
              <Ancoche/>
              <p>
                {article?.translations.find((trans) => (trans.lang === intl.locale)).excerpt}
              </p>
            </Description>
            <AllTexts>
              {(article) ? parse(article?.translations.find((trans) => (trans.lang === intl.locale)).text) : null}
            </AllTexts>
          </DivContent>
        </DivArticle>
        <DivSeeMore>
          <SeeMore>
            <SeparationSeeMore/>
            <SeeMoreText>
              {intl.formatMessage({ id: "seeMore" })}
            </SeeMoreText>
          </SeeMore>
          {article?.related.some((related) => (related.type === 'portrait')) && <DivSectionSeeMore>
            <DivTitleSeeMore>{intl.formatMessage({ id: "portraits" })}</DivTitleSeeMore>
            {
              article?.related.map((related) => (
                (related.type === "portrait") ?
                  <ListPortrait key={related.id} portrait={related} handleClickItemLink={handleClickItemLink} inPortrait={inPortrait} />
                  :
                  null
              ))
            }
          </DivSectionSeeMore>}
          {article?.related.some((related) => (related.type === 'event')) &&
          <DivSectionSeeMore>
            <DivTitleSeeMore>{intl.formatMessage({ id: "links" })}</DivTitleSeeMore>
            {
              article?.related.map((related) => (
                (related.type === "event") ?
                  <ListLink key={related.id} article={related} handleClickItemLink={handleClickItemLink} inFrise={inFrise}/>
                  :
                  null
              ))
            }
          </DivSectionSeeMore>}
          {article?.translations.find((trans) => (trans.lang === intl.locale)).related_ressources && 
          <DivSectionSeeMore>
            <DivTitleSeeMore>{intl.formatMessage({ id: "externalRessource" })}</DivTitleSeeMore>
            <DivRelatedRessource>
              {(article) ? parse(article?.translations.find((trans) => (trans.lang === intl.locale)).related_ressources) : null}
            </DivRelatedRessource>
          </DivSectionSeeMore>}
        </DivSeeMore>
      </RootDiv>
  )
})
export default Article;